import * as z from "zod";
import { MarketingAgentAnalyticsInputSchema } from "./common";

const DiscountTrendPointSchema = z.object({
  date: z.string(), // YYYY-MM-DD format
  withDiscounts: z.number(),
  withoutDiscounts: z.number(),
});

const LinkTrendPointSchema = z.object({
  date: z.string(), // YYYY-MM-DD format
  withLinks: z.number(),
  withoutLinks: z.number(),
});

const WriterMessageTrendsOutputSchema = z.object({
  discountTrends: z.array(DiscountTrendPointSchema),
  linkTrends: z.array(LinkTrendPointSchema),
  emailLinkTrends: z.array(LinkTrendPointSchema),
  smsLinkTrends: z.array(LinkTrendPointSchema),
});

export const getMarketingAgentWriterMessageTrends = {
  name: "getMarketingAgentWriterMessageTrends" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: WriterMessageTrendsOutputSchema,
};
